import React from 'react';
import {r} from "@/utils/responsive";
import {useProgress} from "@/hooks/useProgress";
import IconVision from "@/assets/img/icon_vision.png"
import IconStorage from "@/assets/img/icon_storage.png"
import IconPrint from "@/assets/img/icon_print.png"
import IconShield from "@/assets/img/icon_shield.png"
import IconGuard from "@/assets/img/icon_guard.png"
import IconVisionUnlocked from "@/assets/img/vision_unlocked.png"
import IconStorageUnlocked from "@/assets/img/storage_unlocked.png"
import IconPrintUnlocked from "@/assets/img/print_unlocked.png"
import IconShieldUnlocked from "@/assets/img/shield_unlocked.png"
import IconGuardUnlocked from "@/assets/img/guard_unlocked.png"
import heroAvatar from "@/assets/img/hero_avatar.png"

interface BottomInfoPanelProps extends React.HTMLAttributes<HTMLDivElement> {
}

const BottomInfoPanel: React.FC<BottomInfoPanelProps> = ({className, ...props}) => {
    const {currentStep} = useProgress();

    // Массив иконок достижений (заблокированные состояния)
    const achievementIcons = [IconShield, IconPrint, IconVision, IconGuard, IconStorage];

    // Массив иконок для разблокированных состояний
    const unlockedIcons = [IconShieldUnlocked, IconPrintUnlocked, IconVisionUnlocked, IconGuardUnlocked, IconStorageUnlocked];

    // Функция для проверки разблокировки ачивки
    const isAchievementUnlocked = (iconIndex: number) => {
        return currentStep > iconIndex + 1; // Ачивка разблокирована если прошли соответствующий уровень
    };

    return (
        <div
            {...props}
            style={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                pointerEvents: "none",
                userSelect: "none",
            }}
        >
            <div style={{
                position: "absolute",
                bottom: r.vmax(20),
                right: r.vmax(30),
                display: "flex",
                gap: r.vmax(18),
                alignItems: "end"
            }}>
                <div style={{
                    display: "flex",
                    gap: r.vmax(8),
                }}>
                    {achievementIcons.map((icon, index) => {
                        const isUnlocked = isAchievementUnlocked(index);
                        return (
                            <div key={index} style={{width: r.vmax(90), height: r.vmax(100), position: "relative"}}>
                                {/* Базовая иконка (всегда видимая) */}
                                <img
                                    src={icon}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        filter: 'grayscale(100%)', // Всегда ч/б
                                        opacity: 0.6,
                                    }}
                                    alt={`Achievement ${index + 1}`}
                                />

                                {/* Цветная иконка поверх (показывается только когда разблокирована) */}
                                {isUnlocked && (
                                    <div style={{
                                        width: r.vmax(138),
                                        height: r.vmax(134),
                                        position: "absolute",
                                        top: r.vmax(-14),
                                        left: r.vmax(-24),
                                        opacity: 1,
                                        transition: 'opacity 0.3s ease',
                                    }}>
                                        <img
                                            alt=""
                                            src={unlockedIcons[index]}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
                <div style={{
                    position: 'relative',
                    width: r.vmax(138),
                    height: r.vmax(138),
                }}>
                    <div style={{
                        position: "absolute",
                        width: r.vmax(214),
                        height: r.vmax(201),
                        left: r.vmax(-47),
                        top: r.vmax(-43),
                    }}>
                        <img src={heroAvatar} alt=""
                             style={{width: '100%', height: '100%'}}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BottomInfoPanel;
